import { useState } from "react";
import { faqSection, faqs } from "../lib/content";
import { ChevronIcon } from "./Icons";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="section-pad bg-ink-soft">
      <div className="container-page">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.4fr]">
          <div>
            <span className="eyebrow">{faqSection.eyebrow}</span>
            <h2 className="h-section mt-4">{faqSection.heading}</h2>
            <p className="lead">{faqSection.subheading}</p>
            <p className="mt-6 text-sm text-ink-muted">
              {faqSection.ctaLabel}{" "}
              <a href="/#contact" className="font-semibold text-brand-600 hover:text-brand-700">
                Talk to us
              </a>
              .
            </p>
          </div>

          <div className="divide-y divide-ink-line border-y border-ink-line">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              const panelId = `faq-panel-${index}`;
              const buttonId = `faq-button-${index}`;

              return (
                <div key={faq.q}>
                  <h3>
                    <button
                      type="button"
                      id={buttonId}
                      aria-expanded={isOpen}
                      aria-controls={panelId}
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="flex w-full items-center justify-between gap-6 py-5 text-left"
                    >
                      <span className="text-base font-semibold text-ink">{faq.q}</span>
                      <span
                        className={`shrink-0 text-ink-muted transition-transform duration-200 ${
                          isOpen ? "rotate-180" : ""
                        }`}
                      >
                        <ChevronIcon />
                      </span>
                    </button>
                  </h3>
                  {isOpen && (
                    <div
                      id={panelId}
                      role="region"
                      aria-labelledby={buttonId}
                      className="pb-6 pr-10 text-sm leading-relaxed text-ink-muted"
                    >
                      {faq.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
